/**
 * AI.GEN lines=1-129
 * 用户管理类
 */
import {
  EnvironmentName,
  getSSODomain,
  UserBase,
  UserBaseProfile,
  UserInfo,
} from '@hpfe/common-base';

import { Config } from '@/context/config';
import DingTalkLogin from '@/service/ding-talk-login';
import { domainCookie } from '@/utils/domain-cookie';

export interface UserProfile extends UserBaseProfile {}

const getStorageProfile = () => {
  const storage = localStorage.getItem('userInfo');
  const result: UserProfile = {
    token: '',
  };

  try {
    const info = JSON.parse(storage || '');

    result.token = info.userToken;
  } catch (e) {
    //console.log(e)
  }

  return result;
};

export class User extends UserBase<UserProfile> {
  userInfoKey: string = 'userInfo';
  userInfoKeyByCountryCode: string = '';
  tokenKey: string = '';
  countryCode: string = '';
  upperCaseCountryCode: string = '';
  environmentName: EnvironmentName = EnvironmentName.develop;
  ssoUrl: string = '';
  userInfo: UserInfo | null = null;
  roleNames: string[] = [];
  cityNames: string[] = [];
  userToken: string = '';
  // 扩展用户信息（从 /api/dispatch/auth/information 接口获取）
  extendedUserInfo: {
    userNick?: string | null;
    hpType?: number | null;
    pfType?: number | null;
    cities?: string[] | null;
  } | null = null;

  constructor() {
    super({
      initialProfile: getStorageProfile(),
    });
  }

  init(options: { config: Config }) {
    this.countryCode = options.config.countryCode;
    this.upperCaseCountryCode = this.countryCode.toUpperCase();
    this.environmentName = options.config.environmentName;
    this.tokenKey = `${this.upperCaseCountryCode}_token`;
    this.userInfoKeyByCountryCode = `${this.upperCaseCountryCode}_userInfo`;
    this.ssoUrl = getSSODomain(this.environmentName) || '';
    this.setToken();
  }

  setToken = () => {
    const token = domainCookie.get(this.tokenKey);
    if (token) {
      this.userToken = token;
      localStorage.setItem(this.tokenKey, token);
    }
  };

  setUserInfo = (params: UserInfo) => {
    this.userInfo = params;
    localStorage.setItem(this.userInfoKey, JSON.stringify(params));
  };

  /**
   * 设置扩展用户信息（从 /api/dispatch/auth/information 接口获取）
   */
  setExtendedUserInfo = (params: {
    userNick?: string | null;
    hpType?: number | null;
    pfType?: number | null;
    cities?: string[] | null;
  }) => {
    this.extendedUserInfo = params;
    localStorage.setItem('extendedUserInfo', JSON.stringify(params));
  };

  /**
   * 获取扩展用户信息
   */
  getExtendedUserInfo = () => {
    if (this.extendedUserInfo) {
      return this.extendedUserInfo;
    }
    // 从 localStorage 读取
    try {
      const stored = localStorage.getItem('extendedUserInfo');
      if (stored) {
        this.extendedUserInfo = JSON.parse(stored);
        return this.extendedUserInfo;
      }
    } catch (e) {
      // ignore
    }
    return null;
  };

  logout = () => {
    this.removeToken();
    DingTalkLogin.removeToken();
    DingTalkLogin.jumpToLogin();
  };

  removeToken = (): void => {
    domainCookie.remove(this.tokenKey);
    domainCookie.remove(this.userInfoKeyByCountryCode);
    localStorage.removeItem(this.userInfoKey);
    localStorage.removeItem(this.tokenKey);
  };
}
